import { useEffect, useState } from "react";

export interface IResponsiveHelperResult {
    isResponsive: boolean;
    isMobile: boolean;
}

export function useResponsiveHelper(): IResponsiveHelperResult {
    const [isResponsive, setIsResponsive] = useState(window.innerWidth < 1024);
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 1024px)');

        const handleWindowResize = (e: any) => {
            setIsResponsive(e.matches);
        };

        mediaQuery.addEventListener('change', handleWindowResize);

        return () => {
            mediaQuery.removeEventListener('change', handleWindowResize);
        };
    }, []);


    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');

        const handleWindowResize = (e: MediaQueryListEvent) => {
            setIsMobile(e.matches);
        };

        mediaQuery.addEventListener('change', handleWindowResize);
 
        return () => {
            mediaQuery.removeEventListener('change', handleWindowResize);
        };
    }, []);

    return { isResponsive, isMobile };
}